import React from "react";

function Emoji({ label, symbol }) {
  return (
    <span role="img" aria-label={label}>
      {symbol}
    </span>
  );
}

export default Emoji;
